<template>
  <div>
    <ul class="list-group">
      <li class="list-group-item"
        v-for="creditCard in paymentMethods.cards"
        v-bind:key="creditCard.id"
      >
        <div class="segments" id="wallets">
          <div class="item">
            <img v-if="creditCard.brand == 'MasterCard'" src="../../../static/img/wallets/mastercard.jpg" class="img-responsive" width="90" height="60" style="display:inline;"/>
            <img v-else src="../../../static/img/wallets/visas.jpg" class="img-responsive" width="90" height="60" style="display:inline; padding:5px;"/>
              **** ****<span> {{creditCard.last4}}</span>
          </div>
          <div class="item"><br>{{creditCard.number}}</div>
          <div class="item"><br><a href="#"><i class="fa fa-heart" style="color: pink; font-size:18px;"></i></a></div>
          <div class="item"><br><a href="#"><i class="fa fa-trash" style="color: red; font-size:18px; margin-right:0;" @click.prevent="deleteCard(creditCard.id)"></i></a></div>
        </div>
      </li>
        <div id="loading" style="text-align: center; margin-bottom: 50px;" class="panel-body row-fluid" v-if="loading">
          <svg class="spinner" width="45px" height="45px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
    </ul>
    <div class="alert alert-info fade in" style="text-align:center;" v-show="hasNoCard">
      <a href="#" class="close" data-dismiss="alert">&times;</a>
      <i aria-hidden="true" style="font-size:23px; float:left;" class="fa fa-exclamation-triangle"></i>
      Link a Credit or debit card to your account and use it as a payment method to pay bills<br>
      <router-link to="/account/link/cards" type="button" title="Link a credt card" class="btn btn-info btn-circle btn-lg"><i class="fa fa-plus"></i></router-link>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import {default as swal} from 'sweetalert2'
import {HTTP, account} from '../../services/account-services.js'

Vue.use(Vue2Filters)

export default {
  // name: 'wallet',
  components: {
  },
  data() {
    return {
      active: true,
      account: {},
      paymentMethods: {},
      hasNoCard: false,
      stripeID: '',
      loading: true
    }
  },
  methods: {
    getPaymentMethod() {
      let token = localStorage.getItem('authToken')
      let userId = localStorage.getItem('userId')
      let app = this
      HTTP.get(`/accounts/${userId}/paymentMethods?access_token=${token}`).then(response => {
        app.paymentMethods = response.data
        console.log(response.data)
        // localStorage.setItem('phone', response.data.wallets.phoneNumber)
        // console.log(response.data.wallets[0].phoneNumber)
        if (response.data.wallets.length === 0) {
          app.hasNoWallet = true
        }
        if (response.data.cards.length === 0) {
          app.hasNoCard = true
        }
        if (response.data.banks.length === 0) {
          app.hasNoBank = true
        }
        if (response.data.gifts.length === 0) {
          app.hasNoGift = true
        }
        app.loading = false
        console.log(response.data)
      }).catch(function (error) {
        console.log(error)
      })
    },
    deleteCard(id) {
      console.log('Deleting card id', id)
      let userId = localStorage.getItem('userId')
      let token = localStorage.getItem('authToken')
      swal({
        title: 'Are you sure who want to delete this Card ?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showLoaderOnConfirm: true,
        preConfirm: function (id) {
          return new Promise(function (resolve, reject) {
            let url = `/accounts/${userId}/cards/${id}'?access_token=${token}`
            console.log('Delete card at URL', url)
            setTimeout(function() {
              resolve(
                HTTP.delete(url).then(function(response) {
                  console.log(response)
                })
              )
            }, 1500)
          })
        }
      }).then(() => {
        swal({
          type: 'success',
          title: 'Wallet delete successfully',
          html: 'The Wallet has been deleted !'
        })
        this.getPaymentMethod()
      })
    }
  },
  mounted() {
    this.getPaymentMethod()
    let app = this
    account().then(function(response) {
      app.account = response
      app.stripeID = app.account.stripeCustomerId
      // console.log(app.stripeID)
      console.log(app.account.stripeCustomerId)
    })
  }
}
</script>
<style>
  .list-group-item {
    padding: 3px 10px
  }

  .list-group-item span,
  .list-group-item i {
    margin-right: 10px;
    font-size: 14px;
    color: #337ab7;
  }

  .tilebox-primary {
    border-left-color: #188ae2;
  }

  .tilebox-success {
    border-left-color: #4bd396;
  }

  .tilebox-two {
    border-left: 4px solid #f3f3f3;
    background-color: #f3f3f3;
  }

  .card-box {
    padding: 3px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin-bottom: 20px;
  }

  .col-lg-3 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .row {
    margin-right: -10px;
    margin-left: -10px;
  }

  .tilebox-two i {
    font-size: 45px;
    opacity: 1;
    /*margin-top: 15px;*/
  }

  .text-dark {
    color: #313a46 !important;
  }

  .text-success {
    color: #4bd396 !important;
  }

  .text-primary {
    color: #188ae2 !important;
  }

  .card-box h2 {
    animation: fadeInScale 0.7s ease-in-out;
  }

  .pull-right {
    display: flex;
    justify-content: space-between;
  }

  .ballance span {
    text-align: center;
    font-size: 20px !important;
  }

.pull-right i{
  font-size: 17px;
  margin-top: 5px;;
}
@media (min-width: 480px) {
  .item img{
  padding:5px;
  }
}
@media (max-width: 480px) {
  .item img{
  margin-left: -10px;
  padding-top: 5px;
  padding-bottom: 5px;
  }
  .col-lg-3, .col-xs-12 {
    padding-left: 0;
    padding-right: 0;
  }
}

.segments {
    font-size: 1rem;
    display: flex;
    justify-content: space-between;
    vertical-align: center;
    padding-left: 1.083em;
}
.item{
  font-size: 16px;
}
/* .blueButton{
  font-size: 20px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Cards/Card.vue